import WebhookManagement from './WebhookManagement';
import APIKeyManagement from './APIKeyManagement';
import MetaAdsIntegration from './MetaAdsIntegration';
import GoogleAdsIntegration from './GoogleAdsIntegration';
import { INTEGRATIONS } from '../../utils/constant';

const integrationRoutes = [
  {
    path: '/integrations/webhooks',
    element: <WebhookManagement />,
    permission: INTEGRATIONS,
  },
  {
    path: '/integrations/api-keys',
    element: <APIKeyManagement />,
    permission: INTEGRATIONS,
  },
  {
    path: '/integrations/meta-ads',
    element: <MetaAdsIntegration />,
    permission: INTEGRATIONS,
  },
  {
    path: '/integrations/google-ads',
    element: <GoogleAdsIntegration />,
    permission: INTEGRATIONS,
  },
];

export default integrationRoutes;
